import React, { lazy, Suspense, useState, useMemo } from "react";
import { TabItem, TabControl } from "@abb/abb-common-ux-react";
import SingleLineDiagram from "../Single-Line-Diagram/single-line-diagram";
import "./wnt-navbar.css";

const DigitalTwin = lazy(() => import("../Digital-Twin/digital-twin"));
const GeographicalMap = lazy(() => import("../Geographical-Map/geographical-map"));
const SolarOutputPrediction = lazy(() => import("../Solar-Output-Prediction/solar-output-prediction"));

function WNTNavBar() {
  const [activeTab, setActiveTab] = useState(0);

  const tabConfig = useMemo(() => [
    {
      id: "sld",
      label: "Single Line Diagram",
      component: <SingleLineDiagram />,
    },
    {
      id: "geo",
      label: "Geographical Map",
      component: (
        <Suspense fallback={<div className="lazy-loader">Loading Geographical Map...</div>}>
          <GeographicalMap isActive={activeTab === 1} />
        </Suspense>
      ),
      customClass: "geo-tab-item",
    },
    {
      id: "dt",
      label: "Digital Twin",
      component: (
        <Suspense fallback={<div className="lazy-loader">Loading Digital Twin...</div>}>
          <DigitalTwin isActive={activeTab === 2} />
        </Suspense>
      ),
    },
    {
      id: "solar",
      label: "Solar Output Prediction",
      component: (
        <Suspense fallback={<div className="lazy-loader">Loading Solar Output Prediction...</div>}>
          <SolarOutputPrediction isActive={activeTab === 3} />
        </Suspense>
      ),
    }
  ], [activeTab]);

  const isGeoTab = tabConfig[activeTab]?.id === "geo";

  return (
    <div className="wnt-component-container">
      <div className="wnt-header-container">
        <div className="wnt-header-opt">
          <span>Wide Area Network Twin Framework</span>
        </div>
      </div>

      <div className={`wnt-tabs ${isGeoTab ? "geo-tab-active" : ""}`}>
        <TabControl
          type="primary"
          activeTab={activeTab}
          onTabChange={(_, newIndex) => setActiveTab(newIndex)}
        >
          {tabConfig.map(({ id, label, component, customClass }) => (
            <TabItem
              key={id}
              title={label}
              className={customClass || ""}
            >
              {component}
            </TabItem>
          ))}
        </TabControl>
      </div>
    </div>
  );
}

export default WNTNavBar;